import { createContext, useContext, useState, useCallback } from "react";

const ApplyContext = createContext(null);

export function ApplyProvider({ children }) {
  const [open, setOpen] = useState(false);
  const openApply = useCallback(() => setOpen(true), []);
  const closeApply = useCallback(() => setOpen(false), []);
  return (
    <ApplyContext.Provider value={{ open, openApply, closeApply, setOpen }}>
      {children}
    </ApplyContext.Provider>
  );
}

export function useApply() {
  return useContext(ApplyContext);
}
